
import Modal from './modal'
import GridDash from './grid-dash'
import CustomProductsSelection from './custom-products-selection'

import SideMenu from './side-menu'
import SideMenuHeader from './side-menu/components/SideHeader'

import HeaderMain from './header/main'
import HeaderApps from './header/apps'
import UserApp from './header/components/UserApp'
import TooltipApp from './header/apps/components/TooltipApp'

import Tabs from './tabs'
import ContentCollapsable from './content-collapsable'

export default {
  Modal,
  GridDash,
  CustomProductsSelection,

  SideMenu,
  SideMenuHeader,

  HeaderMain,
  HeaderApps,
  UserApp,
  TooltipApp,
  Tabs,
  ContentCollapsable
}
